import React, { FC } from "react";
import layoutStyles from "./childrenModeGreetingLayout.module.scss";
import styles from "./ChildrenModeFairyForestGreeting.module.scss";

type ChildrenModeFairyForestGreetingProps = {
  title: string;
  subTitle: string;
};

export const ChildrenModeFairyForestGreeting: FC<
  ChildrenModeFairyForestGreetingProps
> = ({ title, subTitle }) => (
  <div className={layoutStyles.root}>
    <p className={styles.text}>{title}</p>
    <p className={styles.text}>{subTitle}</p>
  </div>
);
